module.exports = __webpack_public_path__ + "asset/journal--290359.svg";